import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { contractStepperInitialState } from './state';
import { IContractStepperState } from './types';

export const contractStepperSlice = createSlice({
  name: 'contractStepper',
  initialState: contractStepperInitialState,
  reducers: {
    setContractStepperState: (state, action: PayloadAction<IContractStepperState[]>) => {
      state = action.payload;
      return state;
    },
  },
});
